<template>
    <div class="all-layout">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'AllLayout',
    }
</script>

<style scoped>
.all-layout {
    min-height: 100vh;
    background-color: #003457;
}
</style>
